<template>
  <el-dialog
    title="İnternet Ayarları"
    :visible="Modal"
    center
    width="60%">
    <a @click="$emit('ModalOlayi', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <Yukleniyor :data="lo"></Yukleniyor>
    <table class="table table-sm">
      <thead>
      <tr>
        <th width="200">Mesken Bilgi</th>
        <th width="120">Kullanıcı Adı</th>
        <th width="50">Kullanıcı Sayısı</th>
        <th width="100">Şifre</th>
        <th width="120">Tarife</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="m in MeskenListe">
        <td>{{m.label}}</td>
        <td>{{m.iKadi}}</td>
        <td>
          <el-input v-model="m.iUse"></el-input>
        </td>
        <td>
          <el-input v-model="m.iSifre"></el-input>
        </td>
        <td>
          <el-select v-model="m.iTarife" filterable size="mini" placeholder="Tarife Seçiniz">
            <el-option
              v-for="t in TarifeListe"
              :key="t.id"
              :label="t.TarifeAdi"
              :value="t.id">
            </el-option>
          </el-select>
        </td>
      </tr>
      </tbody>
    </table>
    <hr>
    <div class="dialog-footer text-center">
      <el-button type="primary" size="medium" :disabled="lo" @click="Submit()" icon="el-icon-check">
        Kaydet
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import Yukleniyor from "../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    props: ['Bina_id', 'TarifeListe', 'Modal'],
    data() {
      return {
        MeskenListe: null,
        lo: false,
      }
    },
    methods: {
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'yonetim/mesken/' + this.Bina_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.MeskenListe = response.Liste;
              this.lo = false
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },
      Submit() {
        var Liste = this.MeskenListe;
        this.lo = true;
        this.$store.dispatch("Post", {Liste: Liste, path: '_radius/kullanici/' + this.Bina_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.MeskenListe = response.Liste;
              this.lo = false;
              this.$emit('ModalOlayi', false);
              this.$message.success(response.Mesaj);
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }
    },
    created() {
      this.SayfaYukle();
    }
  }
</script>


<style scoped>
  h5 {
    margin-top: 10px;
    padding: 5px;
    background: #eceef6;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pack/Internet/InternetKurulum.vue